/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const SHOW_ALERT = 'SHOW_ALERT';

export function showAlert(payload) {
    return {type: SHOW_ALERT, payload: payload};
}

export const HIDE_ALERT = 'HIDE_ALERT';

export function hideAlert() {
    return {type: HIDE_ALERT};
}


// WEBPACK FOOTER //
// ./src/_actions/alert.actions.js